import { ERouterName } from "@/types/index";
import MainNavbar from "@/pages/windows/MainNavbar";
import HeadNavbar from "@/pages/windows/HeadNavbar";
import AsideNavbar from "@/pages/windows/AsideNavbar";
// import HomeView from "@/views/HomeView.vue";

const routes = [
  {
    path: "/:pathMatch(.*)*", // 404 兜底路由:ml-citation{ref="6,13" data="citationList"}
    component: () => import("@/views/NotFound.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginView.vue"),
  },
  {
    path: "/",
    redirect: "/devices",
    component: () => import("@/views/IndexView.vue"),
    children: [
      {
        path: "/" + ERouterName.DEVICES,
        name: ERouterName.DEVICES,
        components: {
          default: () => import("@/pages/page-web/Devices.vue"),
          header: MainNavbar,
        },
      },
      // {
      //   path: "/" + ERouterName.COLORS,
      //   name: ERouterName.COLORS,
      //   components: {
      //     default: () => import("@/pages/page-web/Colors.vue"),
      //     header: MainNavbar,
      //   },
      // },
      {
        path: "/" + ERouterName.PILOT_Center,
        name: ERouterName.PILOT_Center,
        components: {
          default: () => import("@/views/UserView.vue"),
          // header: MainNavbar,
        },
      },
      {
        path: "/" + ERouterName.PILOT_Switch,
        name: ERouterName.PILOT_Switch,
        components: {
          default: () => import("@/pages/workspace/EnterService.vue"),
          // header: HeadNavbar,
        },
      },
      {
        path: "/organization",
        components: {
          default: () => import("@/views/HomeView.vue"),
          aside: () => import("@/pages/mobiles/Header.vue"),
          header: HeadNavbar,
        },
        children: [
          {
            path: "/" + ERouterName.INFORMATION,
            name: ERouterName.INFORMATION,
            component: () => import("@/pages/workspace/Information.vue"),
          },
          {
            path: "/" + ERouterName.MEMBER,
            name: ERouterName.MEMBER,
            component: () => import("@/pages/workspace/Member.vue"),
          },
          {
            path: "/" + ERouterName.PERMISSION,
            name: ERouterName.PERMISSION,
            component: () => import("@/pages/workspace/Permission.vue"),
          },
          {
            path: "/role",
            name: "role",
            component: () => import("@/pages/workspace/Role.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/amap",
    component: () => import("@/views/AmapView.vue"),
    children: [
      {
        path: "/" + ERouterName.LIVESTREAM + "/:id",
        name: ERouterName.LIVESTREAM,
        components: {
          default: () => import("@/pages/page-web/LiveStream.vue"),
          header: AsideNavbar,
        },
      },
      {
        path: "/" + ERouterName.HISTORY + "/:id",
        name: ERouterName.HISTORY,
        components: {
          default: () => import("@/pages/page-web/History.vue"),
          header: AsideNavbar,
        },
      },
      {
        path: "/" + ERouterName.COLORS + "/:id",
        name: ERouterName.COLORS,
        components: {
          default: () => import("@/pages/page-web/GasColors.vue"),
          header: AsideNavbar,
        },
      },
    ],
  },
];
export default routes;
